var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { Modal as ArcoModal } from '@arco-design/web-react';
import { normalizeConfig } from './utils';
export function useModal() {
  var _a = ArcoModal.useModal(),
    _modalFuncs = _a[0],
    holderEle = _a[1];
  var oldConfirm = _modalFuncs.confirm;
  var modalFuncs = {
    confirm: function confirm(config) {
      var ref = oldConfirm(normalizeConfig(config));
      return {
        close: ref.close,
        update: function update(newConfig) {
          return ref.update(normalizeConfig(__assign(__assign({}, config), newConfig)));
        }
      };
    }
  };
  ['info', 'success', 'warning', 'error'].forEach(function (type) {
    modalFuncs[type] = function (config) {
      return modalFuncs.confirm(__assign(__assign({}, config), {
        icon: type
      }));
    };
  });
  return [modalFuncs, holderEle];
}